import { createSlice } from '@reduxjs/toolkit';

const userRegionInfoCookie = PULSE.core.localStorage.getStorage(
    'userRegionInfo',
    true
);

let cookieObject = {};

try {
    cookieObject = JSON.parse(userRegionInfoCookie);
} catch (error) {
    console.error('There was a problem parsing the user region info storage');
    PULSE.core.localStorage.clearStorage('userRegionInfo', true);
}

const initialState = {
    timezone: cookieObject?.timezone || moment.tz.guess(true),
    regionName: cookieObject?.name || '',
    id: cookieObject?.id || '',
    location: cookieObject?.timezone?.split('/')[0] || '',
    region: cookieObject?.timezone?.split('/')[1] || ''
};

const selectedRegion = createSlice({
    name: 'selectedRegion',
    initialState,
    reducers: {
        setRegion: (state, action) => {
            state.timezone = action.payload.timezone;
            state.regionName = action.payload.name;
            state.id = action.payload.id;
            state.location = action.payload.location;
            state.region = action.payload.region;
        }
    }
});

if (PULSE.app.redux) {
    PULSE.app.redux.reducers.selectedRegion = {
        root: selectedRegion.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        selectedRegion: selectedRegion.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            selectedRegion: selectedRegion.actions
        },
        reducers: {
            root: {
                selectedRegion: selectedRegion.reducer
            }
        }
    };
}
